export function capitalize(str) {
    return (String(str.charAt(0)).toUpperCase() + String(str.substring(1)).toLowerCase());
}
export function includeBbox(biggerBox, smallBox) {
    const lowerPoints = biggerBox.filter((b, key) => b <= smallBox[key]);
    const highestPoints = biggerBox.filter((b, key) => b >= smallBox[key]);
    return lowerPoints.length === 2 && highestPoints.length === 2;
}
export function equalObject(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = obj1[key];
        const val2 = obj2[key];
        if (isObject(val1) && isObject(val2)) {
            if (!equalObject(val1, val2)) {
                return false;
            }
        }
        else {
            if (val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
export function isDateBetween(startDate, endDate, currentDate) {
    const year = currentDate.getFullYear();
    startDate.setFullYear(year);
    endDate.setFullYear(year);
    const nowMillis = currentDate.getTime();
    return nowMillis >= startDate.getTime() && nowMillis <= endDate.getTime();
}
export const throttle = (callback, delay) => {
    let timer;
    return () => {
        if (timer)
            clearTimeout(timer);
        timer = setTimeout(() => callback(), delay);
    };
};
//# sourceMappingURL=utils.js.map